"use client"
import { useAppSelector } from "@/app/redux/hooks/reduxHooks"
import { SeasonContributionComponent } from "./seasonContributionComponent"
import { SeasonCurrencyConverterComponent } from "./seasonCurrencyConverterComponent"

export const SeasonButtonComponent = () => {
    const credits = useAppSelector((state) => state.auth.credits)
    const rank = useAppSelector((state) => state.dashboard.rank)

    return (
        <section className="flex items-center gap-5">
            <div>
                <SeasonContributionComponent credits={credits} />
            </div>
            <div>
                <SeasonCurrencyConverterComponent credits={credits} />
            </div>
        </section>
    )
}
